<template>
  <v-container>
    <v-card>
      <v-card-title>Create Branch</v-card-title>
      <v-card-text>
        <BranchEditComponent
          :allow-close="false"
          :is-create="true"
          :branch="new BranchDTO()"
          @branch-edit-complete="handleComplete"
          @snack="throwSnack"></BranchEditComponent>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script setup lang="ts">
import { useRouter } from 'vue-router';
import BranchEditComponent from '@/components/branches/BranchEditComponent.vue';
import { SNACKSTATUS } from '@/stores/util';
import { useSnack } from '@/helpers';
import { BranchDTO } from '@/dtos';
const emit = defineEmits<{
  (e: 'snack', objType: string, snackType: SNACKSTATUS, err?: string): void;
}>();
const { throwSnack } = useSnack(emit);
const router = useRouter();

const handleComplete = () => {
  router.push({ name: 'AdminBranchListing' });
};
</script>
<style scoped></style>
